module.exports = __webpack_public_path__ + "img/icon4.8696cd58.png";